import type { GlobalFilterItem } from '@/api-client/dashboard/model';
import {
  convertOperationTypeFromDto,
  convertGlobalFilterValueToTargetTagData,
} from '@/dashboard/features/globalVariables/services/adaptor';
import type { TargetTagData, GlobalVariable } from './globalVariable.types';

/**
 * GlobalFilterItem의 variableType 결정
 *
 * @param item - API 응답의 GlobalFilterItem
 * @returns 'target' 또는 'tag'
 */
export const resolveVariableType = (item: GlobalFilterItem): 'target' | 'tag' => {
  const defaultType = item.globalFilterKeyValues?.at(0)?.tagType === 'attribute' ? 'tag' : 'target';
  if (item.target == null) return defaultType;
  return item.target ? 'target' : 'tag';
};

/**
 * GlobalFilterItem을 GlobalVariable 도메인 모델로 변환
 *
 * @param item - API 응답의 GlobalFilterItem
 * @param allTargets - 전체 타겟 목록 (variableType이 'target'인 경우 별도 API 호출 결과)
 * @returns GlobalVariable 도메인 모델
 */
export const convertToGlobalVariable = (
  item: GlobalFilterItem,
  allTargets: TargetTagData[],
): GlobalVariable => {
  const targets = item.globalFilterKeyValues?.map(convertGlobalFilterValueToTargetTagData) ?? [];
  const variableType = resolveVariableType(item);
  const defaultOperationType =
    item.globalFilterKeyValues?.at(0)?.tagType === 'attribute' ? 'AND' : 'OR';

  return {
    ...item,
    globalFilterId: item.globalFilterId ?? -1,
    aliasName: item.alias ?? '',
    tagKey: item.tagKey ?? '',
    targets,
    allTargets,
    isAster: item.isAster ?? false,
    use: true,
    isMultiSelectType: !item.single,
    variableType,
    operationType: convertOperationTypeFromDto(item.operationType ?? defaultOperationType),
  };
};
